import { render } from "./ModeratorDetailsView.vue?vue&type=template&id=135e2360&scoped=true&ts=true"
import script from "./ModeratorDetailsView.vue?vue&type=script&lang=ts"
export * from "./ModeratorDetailsView.vue?vue&type=script&lang=ts"

import "./ModeratorDetailsView.vue?vue&type=style&index=0&id=135e2360&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135e2360"]])

export default __exports__